<div fxLayout fxLayoutAlign="start center" fxLayoutGap="16px" style="margin-bottom: 32px">
  <sbnb-icon-booking [size]="20"></sbnb-icon-booking>
  <h2 class="nomargin">Set {{ 'CORE.PRODUCT_NAME' | transloco }} up as your channel manager</h2>
</div>

<div class="info-box">
  <div class="info-container margin-bottom-32">
    <!-- Start Booking.com widget code snippet -->
    <a id="booking-widget" (click)="openPopup()" fxHide fxShow.gt-sm data-provider-name="Hospitable.com">
      <button
        data-intercom-target="booking-com-one-property-connect"
        class="fw connect-button bg-booking connect-btn"
        mat-flat-button>
        <sbnb-icon-booking class="absolute-icon" [white]="true" [size]="26"></sbnb-icon-booking>
        <span>Connect with Booking.com</span>
      </button>
    </a>

    <a
      id="booking-widget"
      target="_blank"
      [href]="bookingComRedirect"
      (click)="progress()"
      fxHide
      fxShow.lt-md
      data-provider-name="Hospitable.com">
      <button
        data-intercom-target="booking-com-one-property-connect"
        class="fw connect-button bg-booking connect-btn"
        mat-flat-button>
        <sbnb-icon-booking class="absolute-icon" [white]="true" [size]="26"></sbnb-icon-booking>
        <span>Connect with Booking.com</span>
      </button>
    </a>
    <!-- End Booking.com widget code snippet -->
  </div>

  <div class="text-center">
    <a (click)="progress()" class="text__small link">I already have a pending connection with Hospitable</a>
  </div>
</div>
